import { useState } from 'react';
import useReveal from '../hooks/useReveal';
import { PROCESS_STEPS, AREAS, TESTIMONIALS } from '../data/data';

const FAQS = [
  ['What is the minimum order quantity?','We supply in wholesale quantities. Minimum order is ₹2,000. Most kirana stores order between ₹5,000 and ₹25,000 per delivery. There is no maximum limit.'],
  ['Do you deliver across all of Hyderabad?','Yes! We cover the entire Hyderabad and Secunderabad region including KPHB, Kukatpally, Ameerpet, Banjara Hills, LB Nagar, Dilsukhnagar, Charminar and surrounding areas.'],
  ['How do I place an order?','Simply WhatsApp your shopping list to +91 98765 43210 or give us a call. Our team confirms within 5 minutes. No app or account creation needed.'],
  ['When will my order be delivered?','Orders placed before 12 noon are typically delivered the same day. Orders placed in the afternoon are delivered the next morning.'],
  ['What if I receive a wrong or damaged item?','Call us immediately. We will replace the item on our very next delivery route at no extra charge. Our drivers carry a verification checklist so issues are very rare.'],
  ['Is a GST invoice always provided?','Yes, always. A printed GST invoice is given at the time of every single delivery. Digital copies can also be emailed on request.'],
  ['Do you supply to restaurants and hotels too?','Absolutely. We supply to kirana stores, provision shops, restaurants, hotels, cloud kitchens, canteens and catering services across Hyderabad.'],
  ['What payment methods do you accept?','We accept cash on delivery, bank transfer (NEFT/RTGS), UPI and cheque. Credit terms are available for established customers.'],
];

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item reveal">
      <button className={`faq-btn${open?' open':''}`} onClick={()=>setOpen(!open)}>
        {q}
        <span style={{ fontSize:'1.3rem', flexShrink:0, marginLeft:12, transition:'transform .3s', transform:open?'rotate(45deg)':'', display:'inline-block' }}>+</span>
      </button>
      {open && <div className="faq-body">{a}</div>}
    </div>
  );
}

export default function DeliveryPage() {
  useReveal();
  return (
    <div>
      {/* Hero */}
      <div className="page-hero">
        <div className="page-hero-inner">
          <div className="breadcrumb"><span>Home</span><span className="sep">/</span><span className="active">Delivery Process</span></div>
          <h1>How We Deliver</h1>
          <p style={{ color:'rgba(255,255,255,.75)', fontSize:'1.05rem', lineHeight:1.8, maxWidth:600 }}>
            From your WhatsApp message to your shop's doorstep — our simple, reliable 4-step process explained in full detail.
          </p>
        </div>
      </div>

      {/* 4 Steps — alternating photo + text layout */}
      <section style={{ padding:'96px 5vw', background:'#fff' }}>
        <div className="container">
          <div style={{ textAlign:'center', marginBottom:72 }} className="reveal">
            <div className="tag-line" style={{ justifyContent:'center' }}>Step by Step</div>
            <h2 className="section-title" style={{ textAlign:'center', margin:'0 auto 14px' }}>Our Delivery <em>Process</em></h2>
            <p className="section-sub" style={{ textAlign:'center', margin:'0 auto' }}>Designed to be simple enough for anyone to understand and trust.</p>
          </div>

          {PROCESS_STEPS.map((step,i)=>(
            <div key={i} className="reveal step-row" style={{ display:'grid', gap:60, alignItems:'center', padding:'64px 0', borderBottom:i<3?'1px solid var(--border)':'none', animationDelay:`${i*.08}s` }}>
              {/* Photo */}
              <div style={{ order:i%2===0?0:1 }}>
                <div style={{ borderRadius:14, overflow:'hidden', boxShadow:'var(--shadow-md)', position:'relative' }}>
                  <img src={step.photo} alt={step.title} style={{ width:'100%', height:320, objectFit:'cover', display:'block' }} />
                  <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top, rgba(26,15,5,.5) 0%, transparent 50%)' }} />
                  <div style={{ position:'absolute', bottom:20, left:20, background:'var(--orange)', color:'#fff', padding:'6px 16px', borderRadius:4, fontWeight:700, fontSize:'.82rem', letterSpacing:'.06em' }}>
                    STEP {step.num} OF 04
                  </div>
                </div>
              </div>
              {/* Text */}
              <div style={{ order:i%2===0?1:0 }}>
                <span style={{ display:'inline-block', background:`${step.color}18`, border:`1px solid ${step.color}30`, color:step.color, padding:'5px 16px', borderRadius:4, marginBottom:20, fontWeight:700, fontSize:'.76rem', letterSpacing:'.1em', textTransform:'uppercase' }}>
                  Step {step.num}
                </span>
                <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:'clamp(1.6rem,2.8vw,2.1rem)', fontWeight:800, color:'var(--dark)', marginBottom:14 }}>
                  {step.icon} {step.title}
                </h2>
                <p style={{ fontSize:'.97rem', lineHeight:1.9, color:'var(--text-mid)', marginBottom:26 }}>{step.desc}</p>
                <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
                  {step.points.map((pt,j)=>(
                    <div key={j} style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                      <span style={{ width:22, height:22, background:step.color, color:'#fff', borderRadius:'50%', display:'inline-flex', alignItems:'center', justifyContent:'center', fontSize:'.6rem', fontWeight:800, flexShrink:0, marginTop:1 }}>✓</span>
                      <span style={{ fontSize:'.9rem', color:'var(--text-mid)', lineHeight:1.65 }}>{pt}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
          <style>{`.step-row{grid-template-columns:1fr 1fr!important;} @media(max-width:768px){.step-row{grid-template-columns:1fr!important;} .step-row>div{order:0!important;}}`}</style>
        </div>
      </section>

      {/* Summary cards */}
      <section style={{ padding:'72px 5vw', background:'var(--cream)' }}>
        <div className="container">
          <div style={{ display:'grid', background:'#fff', border:'1px solid var(--border)', borderRadius:12, overflow:'hidden', boxShadow:'var(--shadow-sm)' }} className="reveal journey-strip">
            {PROCESS_STEPS.map((step,i)=>(
              <div key={i} style={{ padding:'28px 20px', textAlign:'center', borderRight:i<3?'1px solid var(--border)':'none', transition:'background .2s' }}
                onMouseEnter={e=>e.currentTarget.style.background='var(--orange-pale)'}
                onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                <div style={{ width:50, height:50, borderRadius:'50%', overflow:'hidden', margin:'0 auto 12px' }}>
                  <img src={step.photo} alt={step.title} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                </div>
                <div style={{ width:28, height:28, background:step.color, color:'#fff', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 10px', fontWeight:800, fontSize:'.8rem' }}>{i+1}</div>
                <div style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, color:'var(--dark)', fontSize:'.9rem', marginBottom:4 }}>{step.title}</div>
                <div style={{ fontSize:'.75rem', color:'var(--text-light)' }}>{step.sub}</div>
              </div>
            ))}
            <style>{`.journey-strip{grid-template-columns:repeat(4,1fr)!important;} @media(max-width:700px){.journey-strip{grid-template-columns:repeat(2,1fr)!important;}}`}</style>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section style={{ padding:'96px 5vw', background:'#fff' }}>
        <div className="container" style={{ maxWidth:820, margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom:56 }} className="reveal">
            <div className="tag-line" style={{ justifyContent:'center' }}>Common Questions</div>
            <h2 className="section-title" style={{ textAlign:'center', margin:'0 auto' }}>Frequently Asked <em>Questions</em></h2>
          </div>
          {FAQS.map(([q,a],i)=><FAQItem key={i} q={q} a={a}/>)}
        </div>
      </section>

      {/* Testimonials */}
      <section style={{ padding:'96px 5vw', background:'var(--cream)' }}>
        <div className="container">
          <div style={{ textAlign:'center', marginBottom:48 }} className="reveal">
            <div className="tag-line" style={{ justifyContent:'center' }}>Real Customers</div>
            <h2 className="section-title" style={{ textAlign:'center', margin:'0 auto' }}>Delivery <em>Success Stories</em></h2>
          </div>
          <div style={{ display:'grid', gap:22 }} className="testi2-grid">
            {TESTIMONIALS.slice(4).map((t,i)=>(
              <div key={i} className="reveal" style={{ background:'#fff', border:'1px solid var(--border)', borderRadius:12, padding:'28px 26px', animationDelay:`${i*.1}s` }}>
                <div style={{ color:'var(--orange)', fontSize:'.95rem', marginBottom:12, letterSpacing:2 }}>{'★'.repeat(t.stars)}</div>
                <p style={{ fontSize:'.93rem', lineHeight:1.85, color:'var(--text-mid)', fontStyle:'italic', marginBottom:20, borderLeft:'3px solid var(--orange-pale)', paddingLeft:16 }}>"{t.text}"</p>
                <div style={{ display:'flex', gap:12, alignItems:'center' }}>
                  <div style={{ width:44, height:44, background:'linear-gradient(135deg, var(--orange), var(--orange-light))', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.82rem', fontWeight:700, color:'#fff', flexShrink:0 }}>{t.initials}</div>
                  <div>
                    <div style={{ fontFamily:"'Playfair Display',serif", fontWeight:600, color:'var(--dark)', fontSize:'.92rem' }}>{t.name}</div>
                    <div style={{ fontSize:'.74rem', color:'var(--text-light)' }}>{t.biz}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <style>{`.testi2-grid{grid-template-columns:repeat(2,1fr)!important;} @media(max-width:640px){.testi2-grid{grid-template-columns:1fr!important;}}`}</style>
        </div>
      </section>

      {/* Coverage */}
      <section style={{ padding:'72px 5vw', background:'#1A0F05', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', inset:0 }}>
          <img src="https://images.unsplash.com/photo-1587474260584-136574528ed5?w=1400&q=70&fit=crop" alt="Hyderabad" style={{ width:'100%', height:'100%', objectFit:'cover', opacity:.15 }} />
        </div>
        <div style={{ position:'relative', zIndex:2 }} className="container">
          <div className="reveal" style={{ textAlign:'center' }}>
            <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:'clamp(1.8rem,3vw,2.4rem)', fontWeight:700, color:'#fff', marginBottom:14 }}>We Cover All of Hyderabad</h2>
            <p style={{ color:'rgba(255,255,255,.62)', marginBottom:36, maxWidth:500, margin:'0 auto 36px', lineHeight:1.8 }}>From KPHB to Charminar, Secunderabad to LB Nagar — our GPS-tracked fleet delivers everywhere.</p>
            <div style={{ display:'flex', flexWrap:'wrap', gap:10, justifyContent:'center' }}>
              {AREAS.map((area,i)=>(<span key={i} style={{ background:'rgba(255,255,255,.1)', border:'1px solid rgba(255,255,255,.18)', color:'rgba(255,255,255,.82)', padding:'7px 15px', borderRadius:20, fontSize:'.82rem', fontWeight:500 }}>📍 {area}</span>))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
